import $ from 'jquery'

$(document).ready(function () {
  dhsv_vc_logisticsmap()
})

function dhsv_vc_logisticsmap() {
  $('.dhsv_vc_logisticsmap__marker').on('click', function () {
    let elem = $(this)
    if (elem.hasClass('active')) {
      elem.removeClass('active')
      elem.next('.dhsv_vc_logisticsmap__popover_click').removeClass('active')
    } else {
      $('.dhsv_vc_logisticsmap__marker').each(function () {
        $(this).removeClass('active')
        $(this)
          .next('.dhsv_vc_logisticsmap__popover_click')
          .removeClass('active')
      })
      elem.addClass('active')
      elem.next('.dhsv_vc_logisticsmap__popover_click').addClass('active')
    }
  })
}
